@if (isEditing()) {
  <form class="form breakout" [formGroup]="dateRangeGroup">
    <hgroup>
      <h3 class="heading-md">Change trip dates</h3>
      <p>Set the dates for your trip.</p>
    </hgroup>
    <p class="warning">
      If you change the dates all members who have RSVPd will need to RSVP
      again.
    </p>
    <at-calendar-range-picker
      [minDate]="minStartDate()"></at-calendar-range-picker>
    <button type="button" class="button primary" (click)="done()">Done</button>
  </form>
} @else {
  <div class="selected-date">
    <hgroup class="date-value" aria-atomic="true">
      @if (isOneDay()) {
        <h3 class="heading-3xs">Trip date</h3>
        <p class="heading-xl">
          {{ selectedDates()?.start | date }}
        </p>
      } @else {
        <h3 class="heading-3xs">Trip dates</h3>
        <p class="heading-xl">
          {{ selectedDates()?.start | date }} to
          {{ selectedDates()?.end | date }}
        </p>
      }
    </hgroup>
    <button class="button tertiary" (click)="edit()">
      <span class="icon icon-edit-2"></span>
      <span class="sr-only">Edit budget</span>
    </button>
  </div>
}
